import Card from "@mui/material/Card"
import CardHeader from "@mui/material/CardHeader"
import CardContent from "@mui/material/CardContent"
import CardActions from "@mui/material/CardActions"
import IconButton from "@mui/material/IconButton"
import MoreVertIcon from "@mui/icons-material/MoreVert"
import { Button, Grid, Menu, MenuItem } from "@mui/material"
import { useState } from "react"
import { Link } from "react-router-dom"
import {
  GroupsRounded,
  SettingsAccessibilityRounded,
} from "@mui/icons-material"
import ScheduleIcon from "@mui/icons-material/Schedule"
import { Stack } from "@mui/system"
import SchoolIcon from "@mui/icons-material/School"
import DateRangeIcon from '@mui/icons-material/DateRange'

export default function BatchCard({ data, edit, remove, noView }) {
  const [menu, setMenu] = useState(null)
  const openMenu = (event) => setMenu(event.currentTarget)
  const closeMenu = () => setMenu(null)

  return (
    <Card
      elevation={0}
      sx={{
        justifyContent: "space-between",
        maxHeight: "44vh",
        height: "100%",
        borderRadius: { sm: 8 },
        boxShadow: "10px 10px 74px -37px rgba(0,0,0,0.3)",
        p: { sm: 2 },
      }}
    >
      <CardHeader
        action={
          <IconButton onClick={openMenu}>
            <MoreVertIcon />
          </IconButton>
        }
        title={data?.name}
      />

      <CardContent sx={{ py: 0 }}>
        {/* <Typography variant="body1" color="text.secondary">
            {data.code}
        </Typography> */}
        <Grid container spacing={2}>
        <Grid item xs={6}>
            <Stack
              direction="row"
              alignItems="center"
              style={{ color: "gray" }}
              gap={1}
            >
              <SettingsAccessibilityRounded /> {data?.teacherCount} teachers
            </Stack>
          </Grid>
          <Grid item xs={6}>
            <Stack
              direction="row"
              alignItems="center"
              style={{ color: "gray" }}
              gap={1}
            >
              <GroupsRounded /> {data?.studentCount} students
            </Stack>
          </Grid>
        </Grid>
      </CardContent>

      {!noView && (
        <CardActions>
          <Link style={{ width: "100%" }} to={`/academic/batches/${data?.id}`}>
            <Button
              variant="contained"
              fullWidth
              sx={{ borderRadius: { sm: 8 } }}
              disableElevation
            >
              View Batch
            </Button>
          </Link>
        </CardActions>
      )}

      <Menu anchorEl={menu} open={Boolean(menu)} onClose={closeMenu}>
        <MenuItem
          onClick={() => {
            edit()
            closeMenu()
          }}
        >
          Edit
        </MenuItem>
        <MenuItem
          onClick={() => {
            remove()
            closeMenu()
          }}
        >
          Delete
        </MenuItem>
      </Menu>
    </Card>
  )
}
